import React from 'react';

import { ConfirmationModal } from '../../component/ConfirmationModal';

export function ConfirmCreatePromotionModal({
  open,
  onConfirm,
  onCancel,
}: {
  open: boolean;
  onConfirm: () => void;
  onCancel: () => void;
}) {
  if (!open) return null;

  return (
    <ConfirmationModal
      title="Are you sure you want to create this new promotion?"
      message="Please ensure all fields are correct before proceeding, as they are not editable after the promotion is created."
      confirmLabel="Create Promotion"
      onConfirm={onConfirm}
      onCancel={onCancel}
    />
  );
}
